import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SearchButton from "../../../components/buttons/search/search-btn";
import CustomTable from "../../../components/table/table";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import { admin_company_details_id, user_company_status, clear_financial_record_changes } from "../admin.api";
import CustomIcons from "../../../components/icons/kIcons.component";
import jwtDecode from "jwt-decode";
import "./view.css";
import Loader from "../../../components/loader/loader";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import moment from "moment";
import { upload_company_logo } from "../../admin/admin.api";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
export default function View(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [url, setUrl] = useState("");
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const eventParams = useParams();
  const handleListData = () => {
    admin_company_details_id(eventParams.id).then((resp) => {
      setData(resp.data);
      setIsActive(false);
    });
  };

  const handleUploadLogo = async () => {
    if (!data?.id) return;
    const { value: confirmed } = await Swal.fire({
      title: "Upload Logo",
      html:
        '<input id="swal-logo" type="file" class="swal2-file" accept=".jpg,.jpeg,.png" />' +
        '<div class="text-muted" style="font-size:12px;margin-top:6px;">Allowed: JPG/JPEG/PNG</div>',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Upload",
      confirmButtonColor: "#0A223D",
      preConfirm: () => {
        const fileInput = document.getElementById("swal-logo");
        const file = fileInput && fileInput.files && fileInput.files[0];
        if (!file) {
          Swal.showValidationMessage("Please choose a logo file");
          return false;
        }
        const validTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!validTypes.includes(file.type)) {
          Swal.showValidationMessage(
            "Invalid file type. Please upload JPG or PNG",
          );
          return false;
        }
        return file;
      },
    });

    if (confirmed) {
      try {
        const fileInput = document.getElementById("swal-logo");
        const file = fileInput.files[0];
        const form = new FormData();
        form.append("logo", file);
        setIsActive(true);
        const resp = await upload_company_logo(data.user_id, form);
        await handleListData();
        Swal.fire({ icon: "success", title: "Logo uploaded" });
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Upload failed",
          text: e?.message || "",
        });
      } finally {
        setIsActive(false);
      }
    }
  };
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const handleDownload = (data, type) => {
    if (type === "logo") {
      let path = `${result}${data.logo}`;
      window.open(path, "_blank");
    } else if (type === "brochure") {
      let path = `${result}${data.upload_proposal}`;
      window.open(path, "_blank");
    } else {
      return false;
    }
  };

  useEffect(() => {
    handleListData();
  }, []);
  const activeStatus = (id) => {
    let status = Number(id);
    if (id === 0) {
      return "Pending";
    } else if (id === 1) {
      return "Submitted for Acceptance";
    } else if (id === 2) {
      return "Approved";
    } else if (id === 3) {
      return "Super Admin Reverted";
    } else if (id === 4) {
      return "Rejected";
    } else if (id === 5) {
      return "Reverted";
    } else {
      return null;
    }
  };
  const saMessage = (status) => {
    Swal.fire({
      inputLabel: "Message",
      input: "textarea",
      showCancelButton: false,
      confirmButtonColor: "#0A223D",
      confirmButtonText: "Submit",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Please describe the reason";
        }
      },
      showCancelButton: true,
    }).then((message) => {
      if (message.isConfirmed === true) {
        let fdata = {};
        if (adminType === 1) {
          if (status === 1) {
            fdata = {
              status_id: status,
              company_id: data.id,
              admin_message: message.value,
            };
          } else {
            fdata = {
              status_id: status,
              company_id: data.id,
              user_message: message.value,
            };
          }
        } else {
          fdata = {
            status_id: status,
            company_id: data.id,
            super_admin_message: message.value,
          };
        }

        setIsActive(true);
        user_company_status(fdata)
          .then((res) => {
            setSnackMessage(res.message);
            setIsSnackError(false);
            setSnackOpen(true);
            setIsActive(false);
          })
          .catch((error) => {
            setSnackMessage(error.message);
            setIsSnackError(true);
            setSnackOpen(true);
            setIsActive(false);
          });
      }
    });
  };
  const handleAdminActions = (status) => {
    let fdata = { status_id: status, company_id: data.id };
    setIsActive(true);
    user_company_status(fdata)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const handleClearChanges = (recordId) => {
    setIsActive(true);
    clear_financial_record_changes(recordId)
      .then((res) => {
        setSnackMessage(res.message || "Status cleared successfully");
        setIsSnackError(false);
        setSnackOpen(true);
        handleListData();
      })
      .catch((err) => {
        setSnackMessage(err.response?.data?.message || "An error occurred");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/kerala-companies-list");
    }
  };
  const handleEdit = () => { };

  const normalizeValue = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      value === "null"
    ) {
      return "--";
    }
    return String(value).trim();
  };

  const normalizeList = (list, mapper) => {
    if (!Array.isArray(list) || list.length === 0) return "--";
    return list
      .map(mapper)
      .filter(Boolean)
      .map((item) => normalizeValue(item))
      .join(", ");
  };

  const hasLastRecord = !!data?.last_record;

  const renderInlineDiff = (oldValue, newValue, isHtml = false) => {
    const previous = normalizeValue(oldValue);
    const current = normalizeValue(newValue);

    if (!hasLastRecord) {
      return isHtml && current !== "--" ? ReactHtmlParser(current) : current;
    }

    if (previous === current) {
      return isHtml && current !== "--" ? ReactHtmlParser(current) : current;
    }

    return (
      <span className="inline-diff-wrap">
        <span className="inline-old-val">
          {isHtml && previous !== "--" ? ReactHtmlParser(previous) : previous}
        </span>
        <span className="inline-diff-arrow">→</span>
        <span className="inline-new-val">
          {isHtml && current !== "--" ? ReactHtmlParser(current) : current}
        </span>
      </span>
    );
  };

  const getFileUrl = (path) => {
    if (!path || path === "null") return "";
    if (String(path).startsWith("http")) return path;
    return `${result}${path}`;
  };

  const renderInlineFileDiff = (oldPath, newPath) => {
    const previous = normalizeValue(oldPath);
    const current = normalizeValue(newPath);

    if (!hasLastRecord) {
      return current === "--" ? "--" : (
        <a href={getFileUrl(newPath)} target="_blank" rel="noopener noreferrer">
          <b>Download File</b>
        </a>
      );
    }

    if (previous === current) {
      return current === "--" ? "--" : (
        <a href={getFileUrl(newPath)} target="_blank" rel="noopener noreferrer">
          <b>Download File</b>
        </a>
      );
    }

    return (
      <span className="inline-diff-wrap">
        <a
          className="inline-old-val"
          href={getFileUrl(oldPath)}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download Old
        </a>
        <span className="inline-diff-arrow">→</span>
        <a
          className="inline-new-val"
          href={getFileUrl(newPath)}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download New
        </a>
      </span>
    );
  };

  const previousCompany = data?.last_record?.company || {};
  const previousDomains = data?.last_record?.domain_types || [];
  const previousProducts = data?.last_record?.product_profiles || [];

  return (
    <div>
      <Loader open={isActive} />

      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <span className="d-flex justify-content-between">
          <h6 className="mb-0 pt-2">
            <b>Company Details</b>
          </h6>
          {/*      
        <button type="button" className="btn btn-primary">
          Back to List
        </button> */}
        </span>
        <hr />
        {/* <button
          type="button"
          className="btn btn-secondary btn-sm  mb-3"
          onClick={(e) => {
            props.history.push("/event-list/");
          }}
        >
          Back
        </button> */}
        <div className="data">
          {/* Company Details */}
          <div className="row">
            <div className="col-12">
              <b>Company Details</b>
            </div>
          </div>
          <div className="row">
            <div className="col-3">Name</div>
            <div className="col-1">:</div>
            <div className="col-7">{renderInlineDiff(previousCompany.company_name, data.company_name)}</div>
          </div>

          {data?.unique_application_ref_no && (
            <div className="row">
              <div className="col-3">Application ID</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.unique_application_ref_no}</div>
            </div>
          )}
          <div className="row">
            <div className="col-3">CIN/Registration No.</div>
            <div className="col-1">:</div>
            <div className="col-7">{renderInlineDiff(previousCompany.cin_number, data.cin_number)}</div>
          </div>
          <div className="row">
            <div className="col-3">Registered Office</div>
            <div className="col-1">:</div>
            <div className="col-7">{renderInlineDiff(previousCompany.address, data.address)}</div>
          </div>

          {/* Contact & Website */}
          <div className="row mt-3">
            <div className="col-12">
              <b>Website, Primary & Alternate Contact</b>
            </div>
          </div>
          {data.site_link && data.site_link !== "null" && (
            <div className="row">
              <div className="col-3">Website</div>
              <div className="col-1">:</div>
              <div className="col-7">{renderInlineDiff(previousCompany.site_link, data.site_link)}</div>
            </div>
          )}
          <div className="row">
            <div className="col-3">Primary Contact Name</div>
            <div className="col-1">:</div>
            <div className="col-7">{renderInlineDiff(previousCompany.person_name, data.person_name)}</div>
          </div>
          <div className="row">
            <div className="col-3">Designation</div>
            <div className="col-1">:</div>
            <div className="col-7">{renderInlineDiff(previousCompany.person_designation, data.person_designation)}</div>
          </div>
          <div className="row">
            <div className="col-3">Email</div>
            <div className="col-1">:</div>
            <div className="col-7">{renderInlineDiff(previousCompany.email, data.email)}</div>
          </div>
          <div className="row">
            <div className="col-3">Mobile</div>
            <div className="col-1">:</div>
            <div className="col-7">{renderInlineDiff(previousCompany.phone_no, data.phone_no)}</div>
          </div>
          {data?.alternate_email && (
            <div className="row">
              <div className="col-3">Alternate Email</div>
              <div className="col-1">:</div>
              <div className="col-7">{renderInlineDiff(previousCompany.alternate_email, data.alternate_email)}</div>
            </div>
          )}
          {data?.alternate_phone && (
            <div className="row">
              <div className="col-3">Alternate Mobile</div>
              <div className="col-1">:</div>
              <div className="col-7">{renderInlineDiff(previousCompany.alternate_phone, data.alternate_phone)}</div>
            </div>
          )}

          <div className="row">
            <div className="col-3">New company / Existing company ?</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {" "}
              {data.company_status === "new_company"
                ? "New Company"
                : data.company_status === "existing_company"
                  ? "Existing Company"
                  : ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Area Type</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.area_type}</div>
          </div>
          {(data?.application_submitted_at ||
            data?.approved_at ||
            data?.created_at) && (
              <>
                {data?.application_submitted_at && (
                  <div className="row">
                    <div className="col-3">Submitted At</div>
                    <div className="col-1">:</div>
                    <div className="col-7">
                      {data.application_submitted_at
                        ? moment(data.application_submitted_at).format(
                          "DD-MM-YYYY",
                        )
                        : ""}
                    </div>
                  </div>
                )}
                {data?.approved_at && (
                  <div className="row">
                    <div className="col-3">Approved At</div>
                    <div className="col-1">:</div>
                    <div className="col-7">
                      {data.approved_at
                        ? moment(data.approved_at).format("DD-MM-YYYY")
                        : ""}
                    </div>
                  </div>
                )}
                {data?.created_at && (
                  <div className="row">
                    <div className="col-3">Created At</div>
                    <div className="col-1">:</div>
                    <div className="col-7">
                      {moment(data.created_at).format("DD-MM-YYYY")}
                    </div>
                  </div>
                )}
              </>
            )}

          {/* Branding & Profile */}
          <div className="row mt-3">
            <div className="col-12">
              <b>Branding & Profile</b>
            </div>
          </div>
          {data?.logo && (
            <div className="row">
              <div className="col-3">Logo</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <button
                  type="button"
                  onClick={(e) => handleDownload(data, "logo")}
                  className="btn btn-reject btn-dark btn-sm"
                >
                  Download Logo
                </button>
              </div>
            </div>
          )}
          {/* {!data?.logo && (
            <div className="row">
              <div className="col-3">Logo (HD PNG/JPG)</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <button
                  type="button"
                  onClick={handleUploadLogo}
                  className="btn btn-approve btn-success btn-sm"
                >
                  Upload Logo
                </button>
              </div>
            </div>
          )} */}
          {data?.upload_proposal && (
            <div className="row">
              <div className="col-3">Brochure/Leaflet</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {renderInlineFileDiff(previousCompany.upload_proposal, data.upload_proposal)}
                <div className="text-muted small">(Max 5MB, .doc/.pdf)</div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-3">Short Company Profile</div>
            <div className="col-1">:</div>
            <div className="col-7">{renderInlineDiff(previousCompany.abstract_project_proposal, data.abstract_project_proposal)}</div>
          </div>

          {/* Business Info */}
          <div className="row mt-3">
            <div className="col-12">
              <b>Business Info</b>
            </div>
          </div>
          <div className="row">
            <div className="col-3">Product List</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {renderInlineDiff(
                normalizeList(previousProducts, (item) => item.product_name),
                normalizeList(data.product_profiles, (item) => item.product_name),
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Domain(s) of Activity</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {renderInlineDiff(
                `${normalizeList(previousDomains, (item) => item.domain_name)}${normalizeValue(previousCompany.any_other_domain) !== "--" ? `, ${normalizeValue(previousCompany.any_other_domain)}` : ""}`,
                `${normalizeList(data.domain_types, (item) => item.domain_name)}${normalizeValue(data.any_other_domain) !== "--" ? `, ${normalizeValue(data.any_other_domain)}` : ""}`,
              )}
            </div>
          </div>

          {Array.isArray(data?.area_management) &&
            data.area_management.length > 0 && (
              <>
                <div className="row mt-3">
                  <div className="col-12">
                    <b>Area Management</b>
                  </div>
                </div>
                {data.area_management.map((am, idx) => (
                  <div className="row" key={idx}>
                    <div className="col-12">
                      <div className="row">
                        <div className="col-3">Location</div>
                        <div className="col-1">:</div>
                        <div className="col-7">{am.location}</div>
                      </div>
                      {am.sub_location && (
                        <div className="row">
                          <div className="col-3">Sub Location</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{am.sub_location}</div>
                        </div>
                      )}
                      {am.area_in_sqft && (
                        <div className="row">
                          <div className="col-3">Area (Sqft)</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{am.area_in_sqft}</div>
                        </div>
                      )}
                      {am.built_space_type && (
                        <div className="row">
                          <div className="col-3">Built Space Type</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{am.built_space_type}</div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </>
            )}
          {/* <div className="row">
            <div className="col-3">Capital Investment (Cr.)</div>
            <div className="col-1">:</div>
            <div className="col-7">{data.capital_investment}</div>
          </div> */}

          {/* Financial Records Section */}
          {/* Financial Records Table */}
          {data.financial_records && data.financial_records.length > 0 && (
            <>
              <div className="row mt-4">
                <div className="col-12">
                  <p className="mb-0" style={{ fontWeight: 700, fontSize: "15px" }}><b>Financial Records & Employment</b></p>
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                <table className="table table-bordered financial-table">
                  <thead className="thead-light">
                    <tr>
                      <th>Financial Year</th>
                      <th>Turnover (Cr)</th>
                      <th>Capital Investment (Cr)</th>
                      <th>Male Employment</th>
                      <th>Female Employment</th>
                      <th>Others</th>
                      <th>SC/ST</th>
                      <th>PWD</th>
                      <th>Direct Emp</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.financial_records.map((record, index) => {
                      const status = record.financial_records_changed || "neutral";
                      const lastRecord = record.last_record ? JSON.parse(record.last_record) : null;

                      const renderVal = (field) => {
                        if (status === "updated" && lastRecord && lastRecord[field] !== undefined && String(lastRecord[field]) !== String(record[field])) {
                          return (
                            <div className="value-diff">
                              <span className="old-val">{lastRecord[field]}</span>
                              <span className="diff-arrow">→</span>
                              <span className="new-val">{record[field]}</span>
                            </div>
                          );
                        }
                        return record[field] || 0;
                      };

                      return (
                        <tr key={record.id || index} className={`record-row-${status}`}>
                          <td><b>{record.financial_year}</b></td>
                          <td>{renderVal("fy_turnover")}</td>
                          <td>{renderVal("capital_investment")}</td>
                          <td>{renderVal("dir_employ_male")}</td>
                          <td>{renderVal("dir_employ_female")}</td>
                          <td>{renderVal("dir_employ_others")}</td>
                          <td>{renderVal("dir_employ_sc_st")}</td>
                          <td>{renderVal("dir_employ_pwd")}</td>
                          <td>{renderVal("direct_emp")}</td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center">
                              {status !== "neutral" && status !== "cleared" && (
                                <button
                                  type="button"
                                  className="btn-clear-status"
                                  title={`Clear ${status} status`}
                                  onClick={() => handleClearChanges(record.id)}
                                >
                                  <CustomIcons iconName="tick" />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {data.financial_records && data.financial_records.length > 0 && (
            <>
              <div className="mt-4">
                <p className="mb-3" style={{ fontWeight: 700, fontSize: "15px",marginLeft:"16px" }} ><b>Financial Overview</b></p>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart
                    data={data.financial_records
                      .map(r => ({
                        financial_year: r.financial_year,
                        turnover: Number(r.fy_turnover) || 0,
                        capital: Number(r.capital_investment) || 0,
                      }))
                      .sort((a, b) => a.financial_year.localeCompare(b.financial_year))}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="financial_year" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="turnover" fill="#0A223D" name="Turnover (Cr)" barSize={40} />
                    <Bar dataKey="capital" fill="#6d797b" name="Capital (Cr)" barSize={40} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
              <div className="mt-4">
                <p className="mb-3" style={{ fontWeight: 700, fontSize: "15px",marginLeft:"16px" }}><b>Employment Overview</b></p>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart
                    data={data.financial_records
                      .map(r => ({
                        financial_year: r.financial_year,
                        totalEmployees: Number(r.direct_emp) || 0,
                      }))
                      .sort((a, b) => a.financial_year.localeCompare(b.financial_year))}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="financial_year" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="totalEmployees" fill="#28a745" name="Total Employees" barSize={40} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </>
          )}

          {/* Other info retained */}
          {data.achievements && data.achievements !== "null" && (
            <div className="row mt-3">
              <div className="col-3">Achievements</div>
              <div className="col-1">:</div>
              <div className="col-7">{renderInlineDiff(previousCompany.achievements, data.achievements)}</div>
            </div>
          )}
          {data.certification && (
            <div className="row mt-2">
              <div className="col-3">Certifications</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {renderInlineDiff(
                  previousCompany.certification,
                  data?.certification != "Other"
                    ? data.certification
                    : data.otherCertification,
                )}
              </div>
            </div>
          )}
          <div className=" row mt-3 ">
            <div className="col-3">Current Application Status</div>
            <div className="col-1">:</div>
            <div className="col-7 blink_me1">
              {activeStatus(data?.project_status)}
            </div>
          </div>
          {data?.admin_message && data?.admin_message !== "" && (
            <div className="row">
              <div className="col-3">Admin Message</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.admin_message}</div>
            </div>
          )}
          {data?.super_admin_message && data?.super_admin_message !== "" && (
            <div className="row">
              <div className="col-3">Super Admin Message</div>
              <div className="col-1">:</div>
              <div className="col-7">{data.super_admin_message}</div>
            </div>
          )}

          {adminType === 1 && (
            <>
              {(data?.project_status === 0 || data?.project_status === 3) && (
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-approve btn-success mr-2"
                    onClick={(e) => saMessage(1)}
                  >
                    Submit for Acceptance
                  </button>
                  <button
                    type="button"
                    className="btn btn-approve btn-warning "
                    onClick={(e) => saMessage(5)}
                  >
                    Revert
                  </button>
                </div>
              )}
            </>
          )}
          {adminType === 2 && (
            <>
              {data?.project_status === 1 && (
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-approve btn-success "
                    onClick={(e) => saMessage(2)}
                  >
                    Approve
                  </button>
                  <button
                    type="button"
                    className="btn btn-approve btn-warning mx-2"
                    onClick={(e) => saMessage(3)}
                  >
                    Revert
                  </button>

                  <button
                    type="button"
                    className="btn btn-reject  btn-danger "
                    onClick={(e) => handleAdminActions(4)}
                  >
                    Reject
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
